import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import {interfaceFactory} from './interface.factory';

import PALETTE_SCHEMA from './interface.palette-schema.yaml';

class InterfaceFeature extends AbstractVisualFeature {
    get name() {
        return 'Interface';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return interfaceFactory(PALETTE);
    }
}

export const Interface = new InterfaceFeature(allVisuals);
